/**
 * SortBar — Sortier-Auswahl fuer ProductView (F10). Rein praesentational.
 *
 * Props:
 *   value        string             — aktuelle Sort-ID (s. PRODUCT_SORT_OPTIONS)
 *   onChange     (id: string)=>void — Callback bei Auswahl
 *   searchActive boolean            — blendet 'relevance' nur bei aktiver Suche ein
 *   isDarkMode   boolean
 *   t            (key)=>string
 */
import React from 'react';
import { ArrowDownUp, ChevronDown } from 'lucide-react';
import { PRODUCT_SORT_OPTIONS } from './sortProducts';

const SortBar = ({ value, onChange, searchActive, isDarkMode, t }) => {
  const options = PRODUCT_SORT_OPTIONS.filter((o) => !o.searchOnly || searchActive);

  return (
    <div className="relative inline-flex items-center">
      <ArrowDownUp className={`w-4 h-4 mr-2 ${isDarkMode ? 'text-white/60' : 'text-slate-400'}`} />
      <span className={`text-sm mr-2 ${isDarkMode ? 'text-white/70' : 'text-slate-500'}`}>
        {t('products.sortLabel')}
      </span>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-label={t('products.sortLabel')}
          className={`appearance-none pl-3 pr-9 py-2 text-sm rounded-xl border focus:ring-2 focus:outline-none transition-colors cursor-pointer ${
            isDarkMode
              ? 'bg-gray-800/40 border-white/20 text-white focus:ring-blue-400/50'
              : 'bg-white border-slate-200 text-slate-800 focus:ring-brand/40'
          }`}
        >
          {options.map((o) => (
            <option key={o.id} value={o.id} className={isDarkMode ? 'bg-gray-800 text-white' : ''}>
              {t(o.labelKey)}
            </option>
          ))}
        </select>
        <ChevronDown
          className={`w-4 h-4 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none ${
            isDarkMode ? 'text-white/60' : 'text-slate-400'
          }`}
        />
      </div>
    </div>
  );
};

export default SortBar;
